enum ConstituentQuickFilter {
  ASSIGNEE_IDS = 'assignee_ids',
  CONSTITUENT_CATEGORIES = 'constituent_categories',
  CONSTITUENT_LABEL_IDS = 'constituent_label_ids',
  CONSTITUENT_TYPE = 'constituent_type',
}

export default ConstituentQuickFilter;
